import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEN from './en/common.json';
import authEN from './en/auth.json';
import validationsEN from './en/validations.json';
import usersListEN from './en/usersList.json';
import profileEN from './en/profile.json';
import partnersEN from './en/partners.json';
import categoriesEN from './en/categories.json';
import localesEN from './en/locales.json';
import regionsEN from './en/regions.json';
import bannersEN from './en/banner.json';
import productsEN from './en/products.json';
import stockBalancesEN from './en/stockBalances.json';
import ordersEN from './en/orders.json';
import subscriptionsEN from './en/subscriptions.json';
import dashboardEN from './en/dashboard.json';
import seoEN from './en/seo.json';
import commissionEN from './en/commission.json';
import contentPagesEN from './en/contentPages.json';
import financialSettingsEN from './en/financialSettings.json';

import commonUA from './ua/common.json';
import authUA from './ua/auth.json';
import validationsUA from './ua/validations.json';
import usersListUA from './ua/usersList.json';
import profileUA from './ua/profile.json';
import partnersUA from './ua/partners.json';
import categoriesUA from './ua/categories.json';
import localesUA from './ua/locales.json';
import bannersUA from './ua/banners.json';
import regionsUA from './ua/regions.json';
import productsUA from './ua/products.json';
import stockBalancesUA from './ua/stockBalances.json';
import ordersUA from './ua/orders.json';
import subscriptionsUA from './ua/subscriptions.json';
import dashboardUA from './ua/dashboard.json';
import seoUA from './ua/seo.json';
import commissionUA from './ua/commission.json';
import contentPagesUA from './ua/contentPages.json';
import redirectUA from './ua/redirects.json';
import settingsUA from './ua/settings.json';
import metaTagsUA from './ua/metaTags.json';
import feedbacksUA from './ua/feedbacks.json';
import financialSettingsUA from './ua/financialSettings.json';

const resources = {
  ua: {
    common: commonUA,
    auth: authUA,
    validations: validationsUA,
    profile: profileUA,
    orders: ordersUA,
    usersList: usersListUA,
    partners: partnersUA,
    categories: categoriesUA,
    locales: localesUA,
    regions: regionsUA,
    banners: bannersUA,
    products: productsUA,
    stockBalances: stockBalancesUA,
    subscriptions: subscriptionsUA,
    dashboard: dashboardUA,
    seo: seoUA,
    commission: commissionUA,
    contentPages: contentPagesUA,
    redirects: redirectUA,
    settings: settingsUA,
    metatags: metaTagsUA,
    feedbacks: feedbacksUA,
    financialSettings: financialSettingsUA,
  },
  en: {
    common: commonEN,
    auth: authEN,
    validations: validationsEN,
    profile: profileEN,
    orders: ordersEN,
    usersList: usersListEN,
    partners: partnersEN,
    categories: categoriesEN,
    locales: localesEN,
    regions: regionsEN,
    banners: bannersEN,
    products: productsEN,
    stockBalances: stockBalancesEN,
    subscriptions: subscriptionsEN,
    dashboard: dashboardEN,
    seo: seoEN,
    commission: commissionEN,
    contentPages: contentPagesEN,
    financialSettings: financialSettingsEN,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'ua',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
